import {
  IconDefinition,
  IconFamily,
} from '@fortawesome/fontawesome-common-types';
import styledIcon, { IconStyles } from './styledIcon';

export const faDoNotEnter = doNotEnter('classic', 'thin');
export const falDoNotEnter = doNotEnter('classic', 'light');
export const fatDoNotEnter = doNotEnter('classic', 'thin');
export const fadDoNotEnter = doNotEnter('duotone', 'thin');
export const fasDoNotEnter = doNotEnter('classic', 'solid');
export const farDoNotEnter = doNotEnter('classic', 'regular');

export default function doNotEnter(
  family: IconFamily,
  style: IconStyles
): IconDefinition {
  return styledIcon(
    family,
    style,
    'do-not-enter',
    512, // width
    512, // height
    'f5ec', // unicode
    [
      [
        'classic',
        'solid',
        'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96 208l320 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16L96 304c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z',
      ],
      [
        'classic',
        'regular',
        'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm128-48l256 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z',
      ],
      [
        'classic',
        'light',
        'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm112-16l0 32c0 4.4 3.6 8 8 8l272 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-272 0c-4.4 0-8 3.6-8 8zm-32 0c0-22.1 17.9-40 40-40l272 0c22.1 0 40 17.9 40 40l0 32c0 22.1-17.9 40-40 40l-272 0c-22.1 0-40-17.9-40-40l0-32z',
      ],
      [
        'classic',
        'thin',
        'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm96-16l0 32c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zm-16 0c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32l0-32z',
      ],
      [
        'duotone',
        'thin',
        [
          'M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm64-16c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32l0-32z',
          'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm96-16l0 32c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zm-16 0c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32l0-32z',
        ],
      ],
    ]
  );
}
